const _ = require('underscore');
const protocolHelpers = require('./protocol');

exports.entityTitlesHash = {
	institutes: 'Места',
	collectives: 'Коллективы',
	publications: 'Публикации',
	news: 'Новости',
	articles: 'Статьи',
	themes: 'Подборки',
	books: 'Книги',
	persons: 'Персоны',
	events: 'События',
	objects: 'Традиции',
	movies: 'Видеоматериалы',
	russia: 'Образы России',
	reviews: 'Обзоры событий',
	terms: 'Термины',
	touristRoutes: 'Туристические маршруты',
	specialProjects: 'Спецпроекты',
	playlists: 'Плэйлисты',
	broadcast: 'Прямые трансляции',
	poems: 'Стихотворения'
};

exports.entityTypeTitlesHash = {
	institutes: 'Место',
	collectives: 'Коллектив',
	publications: 'Публикация',
	news: 'Новость',
	articles: 'Статья',
	themes: 'Подборка',
	books: 'Книга',
	persons: 'Персона',
	events: 'Событие',
	objects: 'Традиция',
	movies: 'Видеоматериал',
	russia: 'Образ России',
	reviews: 'Обзор события',
	touristRoutes: 'Туристический маршрут',
	specialProjects: 'Спецпроект',
	playlists: 'Плэйлист',
	broadcast: 'Прямая трансляция',
	poems: 'Стихотворение'
};

exports.entityTypeGenderHash = {
	institutes: 'neuter',
	collectives: 'neuter',
	publications: 'female',
	news: 'female',
	articles: 'female',
	themes: 'female',
	books: 'female',
	persons: 'female',
	events: 'neuter',
	objects: 'female',
	movies: 'male',
	russia: 'male',
	reviews: 'male',
	playlists: 'male',
	poems: 'neuter'
};

const urlsHash = {
	articles: 'materials',
	themes: 'themes',
	news: 'news',
	publications: 'publications',
	books: 'books',
	movies: 'movies',
	events: 'events',
	terms: 'terms',
	institutes: 'institutes',
	collectives: 'collectives',
	persons: 'persons',
	objects: 'objects',
	reviews: 'reviews',
	touristRoutes: 'touristRoutes',
	broadcast: 'live/broadcast',
	meanwhile: 'meanwhile',
	specialProjects: 'specialProjects',
	poems: 'poems',
	interestUnions: 'interestUnions',
	overviews: 'overviews',
	tags: 'tags',
	specialEvents: 'special-events'
};

exports.apiUrlsHash = {
	materials: 'publications',
	themes: 'publications',
	news: 'publications',
	books: 'books',
	movies: 'movies',
	events: 'events',
	terms: 'terms',
	institutes: 'institutes',
	collectives: 'collectives',
	persons: 'persons',
	objects: 'objects',
	reviews: 'reviews',
	touristRoutes: 'touristRoutes',
	live: 'movies',
	playlists: 'playlists',
	poems: 'poems',
	interestUnions: 'interestUnions',
	overviews: 'overviews'
};

exports.getTermUrl = (term, options) => {
	if (!options.rubric) {
		throw new Error('"options.rubric" is required');
	}

	return `/${[
		options.rubric.path,
		urlsHash.terms,
		term.firstLetter,
		term.name
	].join('/')}`;
};

exports.getEntityUrl = (entityType, entity, _options) => {
	const options = _options || {};

	if (!urlsHash[entityType]) {
		throw new Error(`Unknown entityType "${entityType}"`);
	}

	let urlParts;

	if (entityType === 'terms') {
		return exports.getTermUrl(entity, options);
	}
	if (entityType === 'publications') {
		return exports.getEntityUrl(entity.type, entity, options);
	}
	if (entityType === 'specialProjects') {
		if (entity.canonicalUrl) {
			return entity.canonicalUrl;
		}
		return `https://www.culture.ru/${entity.alias}`;
	}
	if (entityType === 'overviews') {
		const config = options.config.services.cultreg.site;
		const protocol = protocolHelpers.get(config);

		return `${protocol}://${config.host}${
			config.port ? `:${config.port}` : ''
		}/articles/${entity.cultreg._id}/${entity.name}`;
	}
	if (entityType === 'tags') {
		urlParts = [urlsHash[entityType]];

		if (entity.name) {
			urlParts.push(entity.name);
		}

		return `/${urlParts.join('/')}`;
	}
	const prefix = urlsHash[entityType];
	urlParts = [prefix, entity._id];

	if (entity.name) {
		urlParts.push(entity.name);
	}

	return `/${urlParts.join('/')}`;
};

exports.sortedExtend = (src, dst, _options) => {
	const options = _.defaults(_options || {}, { key: '_id' });

	const srcHash = _.indexBy(src, options.key);

	return _.chain(dst)
		.map((item) => {
			if (_.isObject(item)) {
				return _.extend({}, item, srcHash[item[options.key]]);
			}
			return srcHash[item];
		})
		.compact()
		.value();
};

exports.filterParticipants = (participants, type) => {
	return _.chain(participants)
		.filter((participant) => {
			return participant.type.name === type;
		})
		.pluck('person')
		.value();
};

exports.apiEntitiesHash = {
	activities: 'Активности',
	artefacts: 'Артефакты',
	books: 'Книги',
	bids: 'Заявки',
	broadcast: 'Прямые трансляции',
	cities: 'Города',
	contentFrames: 'Фрэймы',
	countries: 'Страны',
	ethnics: 'Этносы',
	events: 'События',
	federalSubjects: 'Регионы',
	feedback: 'Обратная связь',
	files: 'Файлы',
	genres: 'Жанры',
	institutes: 'Институты',
	collectives: 'Коллективы',
	interactive: 'Интерактивы',
	locales: 'Локали',
	localeUnions: 'Группы локалей',
	materials: 'Материалы',
	misprint: 'Опечатки',
	movies: 'Видеопроизведения',
	objects: 'Объекты',
	organizations: 'Организации',
	participantTypes: 'Типы участников',
	persons: 'Персоны',
	playlists: 'Плэйлисты',
	poems: 'Стихотворения',
	promoBlocks: 'Промо-блоки',
	publications: 'Публикации',
	rubricPages: 'Конструкторы страниц',
	rubrics: 'Рубрики',
	tags: 'Тэги',
	terms: 'Термины',
	touristRoutes: 'Туристические маршруты',
	users: 'Пользователи',
	virtualTours: 'Виртуальные туры',
	votings: 'Голосования',
	widgets: 'Виджеты',
	interestUnions: 'Объединение интересов',
	importBlocks: 'Импортированные блоки',
	menu: 'Конструктор меню',
	specialProjects: 'Спецпроекты'
};

exports.importEntityTypeTitlesHash = {
	eipsk: {
		institutes: 'Места',
		events: 'События',
		locales: 'Локали',
		organizations: 'Организации',
		reviews: 'Обзоры событий',
		tags: 'Теги',
		collectives: 'Коллективы',
		broadcast: 'Заявка трансляции\\трансляция'
	},
	meloman: {
		concerts: 'Концерты',
		broadcast: 'Трансляции'
	},
	dcx: {
		objects: 'Объекты НКН',
		lectures: 'Лекции',
		movies: 'Фильмы',
		performances: 'Спектакли',
		broadcast: 'Трансляции'
	},
	cultreg: {
		overviews: 'Обзоры'
	},
	tilda: {
		specialProjects: 'Спецпроекты'
	}
};

exports.importEntityTypesHash = {
	dcx: {
		objects: 'objects',
		lectures: 'movies',
		movies: 'movies',
		performances: 'movies',
		broadcast: 'movies'
	},
	meloman: {
		concerts: 'movies',
		broadcast: 'movies'
	},
	eipsk: {
		events: 'events',
		locales: 'locales',
		organizations: 'organizations',
		institutes: 'institutes',
		reviews: 'reviews',
		tags: 'tags',
		collectives: 'collectives',
		broadcast: 'movies'
	},
	cultreg: {
		overviews: 'importBlocks'
	},
	tilda: {
		specialProjects: 'specialProjects'
	}
};

exports.importEntityTypes = _.chain(exports.importEntityTypesHash)
	.keys()
	.map((source) => {
		return _.keys(exports.importEntityTypesHash[source]);
	})
	.flatten()
	.union()
	.value();

exports.importBlocksEntityTypeTitlesHash = {
	cultreg: {
		overviews: 'Обзоры'
	}
};

exports.importBlocksEntityTypesHash = {
	overviews: 'overviews'
};

exports.apiSortingHash = {
	bids: {
		createDate: 'По\u00A0дате создания (сначала старые)',
		'-createDate': 'По\u00A0дате создания (сначала новые)'
	},
	broadcastBids: {
		createDate: 'По\u00A0дате создания (сначала старые)',
		'-createDate': 'По\u00A0дате создания (сначала новые)',
		publishDate: 'По\u00A0дате проведения (по\u00A0возрастанию)',
		'-publishDate': 'По\u00A0дате проведения (по\u00A0убыванию)'
	},
	nationalProjectBids: {
		createDate: 'По\u00A0дате создания (сначала старые)',
		'-createDate': 'По\u00A0дате создания (сначала новые)',
		'seances.startDate': 'По\u00A0дате проведения (по\u00A0возрастанию)',
		'-seances.startDate': 'По\u00A0дате проведения (по\u00A0убыванию)'
	}
};
